import { getReportParams, report } from 'app/middleware/report';

function setAccountIdentifiers(reportParams, { banId, psId, cmrId }) {
  reportParams.banId = banId ?? '';
  reportParams.psId = psId ?? '';
  reportParams.cmrId = cmrId ?? '';
}

export function dwhCellularDataOnOffPageDisplayed({subscriber, browsingStatus, contact, loginType, sourceUrl, customerName, idNumber, banId, psId, cmrId}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'CellularDataOnOff';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'CellularDataOnOff Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'CellularDataOnOff Page Displayed';
  reportParams.param1 = subscriber;
  reportParams.param2 = `סטטוס גלישה בטעינת עמוד: ${browsingStatus}`;
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  setAccountIdentifiers(reportParams, { banId, psId, cmrId });
  report(reportParams);
}

export function dwhStatusChangeButtonClicked({subscriber, changedBrowsingStatusTo, contact, loginType, sourceUrl, customerName, idNumber, banId, psId, cmrId}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'CellularDataOnOff';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'CellularDataOnOff Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Status Change Button Clicked';
  reportParams.param1 = subscriber;
  reportParams.param2 = `לחץ לעדכן סטטוס ל: ${changedBrowsingStatusTo}`;
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  setAccountIdentifiers(reportParams, { banId, psId, cmrId });
  report(reportParams);
}

export function dwhCellularDataStatusChangeSuccess({subscriber, browsingStatusAfterProcess, contact, loginType, sourceUrl, customerName, idNumber, banId, psId, cmrId}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'CellularDataOnOff';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Cellular Data Status Change';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Success';
  reportParams.param1 = subscriber;
  reportParams.param2 = `סטטוס גלישה בסיום הפעולה: ${browsingStatusAfterProcess}`;
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  setAccountIdentifiers(reportParams, { banId, psId, cmrId });
  report(reportParams);
}

export function dwhCellularDataStatusChangeError({subscriber, browsingStatusAfterError, contact, loginType, sourceUrl, customerName, idNumber, banId, psId, cmrId}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'CellularDataOnOff';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Cellular Data Status Change';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.param1 = subscriber;
  reportParams.param2 = `סטטוס גלישה לאחר שגיאה: ${browsingStatusAfterError}`;
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  setAccountIdentifiers(reportParams, { banId, psId, cmrId });
  report(reportParams);
}
